import * as SetInvestmentDataTypes from 'src/actions/investment/set-data/Types';
import Investment from 'src/entities/Investment';
import { SetInvestmentData, SetInvestmentDataAction } from 'src/actions/investment/set-data/SetInvestmentData.actions';

export interface SetInvestmentState {
  investment?: Investment;
  loading: boolean;
}

const initialState: SetInvestmentState = {
  loading: false
};

export function SetInvestmentReducer(state: SetInvestmentState = initialState,
                                     action: SetInvestmentDataAction): SetInvestmentState {
  switch (action.type) {
    case SetInvestmentDataTypes.SET_INVESTMENT_DATA:
      const investment: Investment = (action as SetInvestmentData).payload;
      return {...state, investment: investment, loading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/investment/SetInvestmentReducer.tsx